/* Jeux de Lumière — configurateur de néon (aperçu lumineux en direct).
   Modes : « neon » (fiche produit, texte), « logo » (fiche produit, logo envoyé), « demo » (section d'accueil).
   Règles : aucun MutationObserver sur le bouton d'ajout ; le bouton est désactivé (disabled) tant que le
   texte manque ; le bouton de paiement dynamique est masqué par la feuille de style. */
(function () {
  'use strict';
  if (window.jdlNeonInit) return;
  window.jdlNeonInit = true;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* Ajuste la taille du texte pour qu'il tienne dans la scène (largeur et hauteur). */
  function fit(textEl, box) {
    if (!textEl || !box) return;
    /* Mise en scène « haut » : l'enseigne tient sur le mur, au-dessus du mobilier de la photo. */
    var maxW = box.clientWidth * 0.84, maxH = box.clientHeight * (box.getAttribute('data-pos') === 'haut' ? 0.42 : 0.62);
    var size = Math.min(150, Math.max(28, box.clientWidth / 5));
    textEl.style.fontSize = size + 'px';
    var guard = 0;
    while ((textEl.scrollWidth > maxW || textEl.scrollHeight > maxH) && size > 14 && guard < 60) {
      size = size * 0.93; guard++;
      textEl.style.fontSize = size + 'px';
    }
  }

  function ignite(sign) {
    sign.classList.remove('is-igniting');
    void sign.offsetWidth; /* relance l'animation */
    sign.classList.add('is-igniting');
  }

  function setup(root) {
    if (root.__jn) return;
    root.__jn = true;
    var mode = root.getAttribute('data-jn-mode') || 'neon';
    var stage = $(root, '[data-jn-stage]');
    var sign = $(root, '[data-jn-sign]');
    var text = $(root, '[data-jn-text]');
    var input = $(root, '[data-jn-input]');
    var count = $(root, '[data-jn-count]');
    var colorName = $(root, '[data-jn-color-name]');
    var err = $(root, '[data-jn-err]');
    var form = root.closest('form');
    var addBtn = form ? form.querySelector('[name="add"], .add_to_cart, button[type="submit"]') : null;
    var defaultText = text ? text.textContent : '';

    function render() {
      if (!text) return;
      var v = input ? input.value.replace(/\r/g, '') : '';
      var lines = v.split('\n').slice(0, 3);
      if (input && v.split('\n').length > 3) { input.value = lines.join('\n'); }
      var shown = lines.join('\n').trim();
      text.textContent = shown || defaultText;
      text.classList.toggle('is-placeholder', !shown);
      if (count && input) count.textContent = input.value.length;
      fit(text, stage);
      lock();
    }

    /* Verrou du bouton d'ajout tant que le texte du néon est vide. Le thème réactive le bouton à chaque
       changement de variante : lock() repasse après lui (écouteur « change » plus bas). Au déverrouillage,
       le bouton ne se rallume que si la variante choisie est disponible. */
    function variantAvailable() {
      var idEl = form ? form.querySelector('[name="id"]') : null;
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      var list = (typeof variants !== 'undefined' && variants) ? variants : [];
      for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i].available !== false; }
      return true;
    }
    function lock() {
      if (mode !== 'neon' || !addBtn || !input) return;
      var empty = input.value.trim() === '';
      if (empty) {
        addBtn.disabled = true;
        addBtn.setAttribute('aria-disabled', 'true');
        addBtn.classList.add('jn-locked');
      } else if (addBtn.classList.contains('jn-locked')) {
        addBtn.classList.remove('jn-locked');
        if (variantAvailable()) { addBtn.disabled = false; addBtn.setAttribute('aria-disabled', 'false'); }
      }
    }

    /* Police */
    $$(root, '[data-jn-font]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked || !text) return;
        /* bv-premium.css impose « font-family: inherit !important » aux div et span : la police du néon
           doit être posée en !important, sinon l'aperçu reste dans la police du thème */
        text.style.setProperty('font-family', "'" + r.getAttribute('data-jn-font') + "', cursive", 'important');
        setTimeout(function () { fit(text, stage); }, 60);
        ignite(sign);
      });
    });
    /* Couleur */
    $$(root, '[data-jn-color]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        sign.style.setProperty('--c', r.getAttribute('data-jn-color'));
        if (colorName) colorName.textContent = r.value;
        ignite(sign);
      });
    });
    /* Support */
    $$(root, '[data-jn-support]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) sign.setAttribute('data-support', r.getAttribute('data-jn-support')); });
    });
    /* Mise en scène : la photo est chargée avant d'être posée (pas de fond vide pendant le chargement) ;
       un clic plus récent l'emporte sur un chargement plus lent. */
    var sceneTok = 0;
    $$(root, '[data-jn-bg]').forEach(function (b) {
      b.addEventListener('click', function () {
        var tok = ++sceneTok, src = b.getAttribute('data-jn-src');
        $$(root, '[data-jn-bg]').forEach(function (x) {
          x.classList.toggle('is-active', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        var apply = function () {
          if (tok !== sceneTok) return;
          stage.setAttribute('data-bg', b.getAttribute('data-jn-bg'));
          stage.setAttribute('data-tone', b.getAttribute('data-jn-tone') || 'sombre');
          stage.setAttribute('data-pos', b.getAttribute('data-jn-pos') || 'centre');
          if (src) stage.style.setProperty('--jn-scene', 'url("' + src + '")');
          stage.classList.remove('is-loading');
          if (text) fit(text, stage);
        };
        if (!src) { apply(); return; }
        stage.classList.add('is-loading');
        var im = new Image();
        im.onload = im.onerror = apply;
        im.src = src;
      });
    });
    /* Allumé / éteint */
    var power = $(root, '[data-jn-power]');
    if (power) power.addEventListener('click', function () {
      var on = !sign.classList.contains('is-on');
      sign.classList.toggle('is-on', on);
      power.classList.toggle('is-on', on);
      power.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = $(power, '[data-jn-power-label]'); if (l) l.textContent = on ? 'Allumé' : 'Éteint';
      if (on) ignite(sign);
    });

    /* Taille affichée : lue dans l'option de la variante choisie (« 60 cm », « 100 cm »...) */
    var variants = [];
    try { variants = JSON.parse(($(root, '[data-jn-variants]') || {}).textContent || '[]'); } catch (e) {}
    var sizeBox = $(root, '[data-jn-size]'), sizeLabel = $(root, '[data-jn-size-label]');
    function showSize() {
      if (!form || !sizeBox) return;
      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      var v = variants.filter(function (x) { return x.id === id; })[0];
      var m = v ? (v.title || '').match(/(\d{2,3})\s*(cm|CM)/) : null;
      if (m) { sizeLabel.textContent = 'Largeur ' + m[1] + ' cm'; sizeBox.hidden = false; }
      else { sizeBox.hidden = true; }
    }
    /* Couleur portée par une option du produit (« Couleur du néon ») : l'aperçu suit la variante choisie */
    var COLORS = { 'blanc chaud': '#ffd9a0', 'blanc froid': '#eef5ff', 'blanc': '#f5f7ff', 'bleu glacier': '#6ce6ff',
      'bleu de glace': '#6ce6ff', 'bleu': '#2e6bff', 'rouge': '#ff2e3e', 'vert': '#39ff6a', 'violet': '#a54bff',
      'rose': '#ff4fa3', 'rose peche': '#ffb39a', 'orange': '#ff8a00', 'jaune': '#ffe14d', 'lilas': '#d59bff',
      'turquoise': '#2ee6d6', 'citron': '#e8ff4d', 'rose clair': '#ffb3d9', 'rose vif': '#ff2d95',
      'rose pale': '#ffc4e1', 'fuchsia': '#ff2dbe', 'magenta': '#ff2dbe', 'jaune dore': '#ffc93c', 'jaune citron': '#e8ff4d',
      'dore': '#ffc93c', 'or': '#ffc93c', 'ambre': '#ffb000', 'bleu fonce': '#2e4bff', 'bleu roi': '#2e4bff', 'bleu ciel': '#7cc8ff',
      'bleu clair': '#7cc8ff', 'vert clair': '#7dff9a', 'vert menthe': '#5dffc0', 'violet clair': '#c58bff', 'mauve': '#c58bff',
      'blanc naturel': '#fff1d6', 'blanc neutre': '#fff1d6', 'blanc pur': '#f5f7ff' };
    var colorOpt = root.getAttribute('data-jn-color-opt');
    function variantColor() {
      if (!form || colorOpt === null || colorOpt === '') return;
      var idEl = form.querySelector('[name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      var v = variants.filter(function (x) { return x.id === id; })[0];
      if (!v) return;
      var name = (v.options || [])[parseInt(colorOpt, 10)] || '';
      var key = name.toLowerCase();
      if (key.normalize) key = key.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      key = key.trim();
      // Coloris inconnu de la table : repli sur le premier mot (« Rose néon » -> rose, « Bleu nuit » -> bleu)
      var hex = COLORS[key] || COLORS[key.split(/[\s,(-]+/)[0]];
      if (!hex) return;
      sign.style.setProperty('--c', hex);
      ignite(sign);
    }
    if (form) {
      form.addEventListener('change', function (e) {
        if (!root.contains(e.target)) { setTimeout(showSize, 30); setTimeout(variantColor, 40); setTimeout(lock, 90); setTimeout(lock, 400); }
      });
      showSize();
      variantColor();
    }

    /* Mode logo : affiche le fichier choisi dans le champ « Votre visuel » de bv-perso */
    if (mode === 'logo' && form) {
      var img = $(root, '[data-jn-logo-img]'), empty = $(root, '.jn__logo-empty');
      form.addEventListener('change', function (e) {
        var f = e.target && e.target.files && e.target.files[0];
        if (!f || !/^image\//.test(f.type) || !img) return;
        var rd = new FileReader();
        rd.onload = function () { img.src = rd.result; img.hidden = false; if (empty) empty.hidden = true; ignite(sign); };
        rd.readAsDataURL(f);
      });
    }

    /* Saisie */
    if (input) {
      input.addEventListener('input', render);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.split('\n').length >= 3) e.preventDefault();
      });
    }
    /* Le thème rallume le bouton en s'initialisant (et après certains changements de variante) : le verrou
       repasse après lui, puis une vérification légère tant que le texte est vide (pas de MutationObserver :
       il fige la page avec la barre d'achat collante). */
    if (mode === 'neon' && addBtn && input) {
      setTimeout(lock, 300); setTimeout(lock, 1200);
      setInterval(function () { if (input.value.trim() === '' && !addBtn.disabled) lock(); }, 700);
    }
    /* Garde au moment de l'ajout : texte obligatoire en mode néon */
    if (form && mode === 'neon') {
      form.addEventListener('submit', function (e) {
        if (input && input.value.trim() === '') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (err) err.hidden = false; input.focus();
        }
      }, true);
      if (addBtn) addBtn.addEventListener('click', function (e) {
        if (input && input.value.trim() === '') {
          e.preventDefault(); e.stopImmediatePropagation();
          if (err) err.hidden = false; input.focus();
        }
      }, true);
    }

    /* Démo de la page d'accueil : texte qui s'écrit tout seul tant que le visiteur n'a pas tapé */
    if (mode === 'demo' && input) {
      var words = (root.getAttribute('data-jn-words') || '').split('|').filter(Boolean);
      var wi = 0, typing = null, touched = false;
      input.addEventListener('focus', function () { touched = true; if (typing) clearTimeout(typing); });
      (function cycle() {
        if (touched || !words.length) return;
        var w = words[wi % words.length], i = 0; wi++;
        (function step() {
          if (touched) return;
          input.value = w.slice(0, i); render();
          if (i++ < w.length) typing = setTimeout(step, 85);
          else typing = setTimeout(cycle, 2300);
        })();
      })();
      var link = $(root, '[data-jn-cta]');
      if (link) link.addEventListener('click', function () {
        try { sessionStorage.setItem('jdlNeonTexte', input.value || ''); } catch (e) {}
      });
    }
    /* Reprise du texte tapé sur l'accueil */
    if (mode === 'neon' && input && !input.value) {
      try { var saved = sessionStorage.getItem('jdlNeonTexte'); if (saved) input.value = saved; } catch (e) {}
    }

    render();
    ignite(sign);
    window.addEventListener('resize', function () { fit(text, stage); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(text, stage); });
  }

  function boot() { $$(document, '[data-jn]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
